import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import TxDetails from "./pages/TxDetails";
import { ConfigProvider } from "antd";
import Profile from "./pages/Profile";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#000000",
          colorInfo: "#000000",
          borderRadius: 1,
        },
      }}
    >
      <div className="flex flex-col justify-between items-center  bg-[#EEEEEF] min-h-[100vh] w-full pt-8">
        <div className="max-w-[1200px] min-h-[70vh] w-full bg-white p-4 border rounded-md flex flex-col gap-5 shadow-sm">
        <Router>
          <Routes>
            <Route index element={<Home />} />
            <Route path="/tx/:hash" element={<TxDetails />} />
            <Route path="/wallet/:id/artwork/:artid" element={<Profile />} />
          </Routes>
        </Router>
        </div>
        <Footer />
      </div>
    </ConfigProvider>
  );
}

export default App;
